import {
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Checkbox,
    Divider,
    Box,
    Typography,
    Chip
  } from "@mui/material";
  import { useState, useMemo } from "react";
  import { SearchInput } from "../contants/SearchInput.js";
  import React from 'react'
      

  const MenuItems = React.memo(function MenuItems({optionItems, selectedValue, filteredItems, onChange, setOpen, isAllSelected, CustomRankChangeCell}) {
    return (
      <>
        {
        filteredItems.map((filteredItem) => (
          <MenuItem
            key={filteredItem}
            value={filteredItem}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0,
            }}
          >
            <Box 
              sx={{ display: "flex", alignItems: "center" }}
                onClick={(e) => {
                  e.stopPropagation();
                  // 배열 아닌 경우도 처리
                  const current = Array.isArray(selectedValue) ? selectedValue : [];

                  // 값 추가/제거
                  let newValue = [];
                  if (current.length === 1 && current[0] === "전체") {
                    newValue = optionItems.filter((item) => item !== "전체" && item !== filteredItem);
                  // if (current === "전체"){
                  //   newValue = optionItems.filter((item) => item !== filteredItem)
                  } else if ((optionItems.length-1) === current.length && !current.includes(filteredItem)) { 
                    newValue = ["전체"]
                  } else {
                    newValue = current.includes(filteredItem) 
                    ? current.filter((item) => item !== filteredItem)
                    : [...current, filteredItem];
                  }

                  onChange(newValue); // 상태 갱신
              }}
            >
              <Checkbox 
                size="small" 
                // checked={Array.isArray(valueList) && valueList.includes(filterItem)}
                checked={isAllSelected || selectedValue.includes(filteredItem)}
                onClick={(e) => {
                  e.stopPropagation();
                  // 배열 아닌 경우도 처리
                  const current = Array.isArray(selectedValue) ? selectedValue : [];

                  // 값 추가/제거
                  let newValue = [];
                  if (current.length === 1 && current[0] === "전체") {
                    newValue = optionItems.filter((item) => item !== "전체" && item !== filteredItem);
                  // if (current === "전체"){
                  //   newValue = optionItems.filter((item) => item !== filteredItem)
                  } else if ((optionItems.length-1) === current.length && !current.includes(filteredItem)) { 
                    newValue = ["전체"]
                  } else {
                    newValue = current.includes(filteredItem)
                    ? current.filter((item) => item !== filteredItem)
                    : [...current, filteredItem];
                  }

                  onChange(newValue); // 상태 갱신
                }}
              />
              {CustomRankChangeCell !== undefined ? (
                <CustomRankChangeCell rankChange={filteredItem} />
              ) : (
                <Typography fontSize={10}> {filteredItem} </Typography>
              )}
            </Box>
            <Box
              onClick={(e) => {
                e.stopPropagation();
                onChange([filteredItem]);
                setOpen(false);
              }}
              sx={{
                px: 1,
                py: 0.5,
                backgroundColor: '#e3f2fd', // 밝은 파란 계열로 더 잘 보이게
                borderRadius: 1,
                cursor: 'pointer',
                fontSize: '10px',
                color: 'primary.main',
                fontWeight: 500,
                '&:hover': {
                  backgroundColor: '#bbdefb', // hover 시 더 진해짐
                },
              }}
            >
              지정
            </Box>
          </MenuItem>
        ))}
        </>
      );
  });
  
  export function CustomMultiSelect({ label, labelId, optionItems, selectedValue, onChange, width, CustomRankChangeCell }) {

    // 드롭박스 액션
    const [open, setOpen] = useState(false);
    const isAllSelected = selectedValue.includes("전체");
    const handleChange = (event) => {
      const selected = event.target.value;
      if (selected.includes("전체") && selected.length > 1) {
        onChange(["전체"]);
        return;
      }
      onChange(selected);
    };
  
    // 검색용
    const [search, setSearch] = useState("");
    const filteredItems = useMemo(() => {
      const keyword = search.trim().toLowerCase();
    
      // 검색어가 비어있으면 전체 목록 반환
      if (!keyword) {
        return optionItems;
      }
    
      return optionItems.filter((item) => {
    
        // "new" 검색 → 999 필터
        if (item === 999 && keyword === "new") return true;
    
        // "-" 검색 → 0만 필터
        if (keyword === "-" && item === 0) return true;
    
        // "0" 검색 → 0만 필터
        if (keyword === "0" && item === 0) return true;
    
        // 숫자 검색: keyword가 숫자라면 양/음수 모두 검사 (단, "-" 단독은 제외됨)
        const keywordAsNumber = Number(keyword);
        if (
          !isNaN(keywordAsNumber) &&
          keyword !== "-" && // "-"는 숫자 0 처리에서 이미 처리함
          Math.abs(Number(item)) === keywordAsNumber
        ) {
          return true;
        }
    
        return false; // 그 외는 필터에서 제외
      });
    }, [search, optionItems]);
    
    return (  
      <FormControl fullWidth size="small">
        <InputLabel id={labelId} sx={{ fontSize: '14px', fontWeight: "bold" }}>{label}</InputLabel>
        <Select
          type="text"
          label={labelId}
          multiple
          open={open}
          onOpen={() => {
            setOpen(true)
          }}
          onClose={() => {
            setOpen(false);
            if (selectedValue.length === 0) {
              onChange(["전체"]);
            }
          }}
          MenuProps={{
            PaperProps: {
              onClick: (e) => {
                // 드롭다운 내부 클릭 시 포커스 날아가는 기본 동작 방지
                e.stopPropagation();
              },
              onMouseDown: (e) => {
                e.stopPropagation(); // 포커스 방지용 추가!
              }
            },
          }}
          value={selectedValue}
          onChange={handleChange}
          fullWidth
          size="small"
          sx={{ height: 40, width: {width}, fontSize: "10px", cursor: "pointer"}}
          renderValue={(selected) => {
            if (selected.includes("전체")) {
              return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1}}>
                  <Chip label="전체" size="small" sx={{fontSize: "10px"}}/>
                </Box>
              );
            }
            if (selected.length === 1) {
              return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Chip label={selected[0]} size="small" sx={{fontSize: "10px"}}/>
                </Box>
              );
            }
            return (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Chip label={selected[0]} size="small" sx={{fontSize: "10px"}}/>
                <Typography variant="body2" color="text.secondary" sx={{fontSize: "10px"}}>
                  외 {selected.length - 1}
                </Typography>
              </Box>
            );
          }}
        >
          {/* 전체 항목 */}
          <MenuItem 
            value="전체"
            sx={{py: 0}}
          >
            <Checkbox
              checked={isAllSelected}
              indeterminate={selectedValue.length > 0 && !isAllSelected}
              size="small"
            />
            <Typography fontSize={10}>
              전체
            </Typography>
          </MenuItem>
  
          <Divider sx={{ my: 1 }} />
  
          {/* 검색 */}
          <SearchInput 
            textValue={search} 
            onChange={(e) => setSearch(e.target.value)} 
            autoFocus
          />
          {/* 카테고리 항목 */}
          {
            // MenuItems(filteredItems, value, onChange, setOpen)
          }
          <MenuItems 
            optionItems={optionItems} 
            selectedValue={selectedValue}
            filteredItems={filteredItems}
            onChange={onChange} 
            setOpen={setOpen} 
            isAllSelected={isAllSelected}
            CustomRankChangeCell={CustomRankChangeCell}
          />
        </Select>
      </FormControl>
    );
  }